import React, {Component} from 'react';
import {connect} from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import LoginClass from '../shared/loginClass/LoginClass';
import { Redirect, withRouter } from 'react-router-dom';
import ToolkitContainer from '../containers/Toolkit/ToolkitContainer'
import Main from '../routes';
import { checkUser, setUserLogout} from '../store/actions/userActions';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
        isLoggingOut: false,
        isLoggedIn: false,
        loginAfterVerify: false,
    };

    this.cognitoAuth = new LoginClass();
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.isLoggedIn && !this.state.isLoggedIn){
      this.setState({isLoggedIn: true} );
    }

    if (nextProps.isLoggedIn && !this.state.isLoggedIn && nextProps.initialTokenRequestData) {
      this.setState({ isLoggedIn: true, withTokenLoaded: true } );
    }
  }

  componentWillUnmount() {
    clearInterval(this.autoLogoutTimer);
  }

  componentDidUpdate(prevProps){
    const isLoggingOut = prevProps.isLoggedIn && !this.props.isLoggedIn;
    if (isLoggingOut) {
        clearInterval(this.getUserTokeInterval);
        this.setState({ isLoggingOut: true });
        setTimeout(() => {
            this.setState({ isLoggingOut: false });
        }, 3000);
    }
  }


  checkLastActivity = (firstTime) => { // check last activity and logout when 15 min is passed
      
      const lastActivity = localStorage.getItem('lastActivity');
      if ((this.props.isLoggedIn || firstTime) && lastActivity) {
        const fifteenMinutes = 15 * 60 * 1000;
        const activityValidDate = Date.now() - fifteenMinutes; // min date
        const automaticLogout = Number(lastActivity) && Number(lastActivity) <= activityValidDate;
        if (automaticLogout) {
          this.props.dispatch(setUserLogout());
          if (this.props.location.pathname === '/account') {
            this.context.router.push({ pathname: '/' });
          }
        }
      }
      if (this.props.isLoggedIn && !lastActivity) localStorage.setItem('lastActivity', Date.now());
    };

  render() {
    return (
      <MuiThemeProvider>
        <Main isLoggedIn={this.props.isLoggedIn}/>
      </MuiThemeProvider>

    )
  }
}

function loadStyleSheet(url) {
  let main = document.getElementById('main-style');
  main.href = url;
}

function MapStateToProps(state, ownProps) {
  return {
      user: state.user,
      forgotPassPending: state.user.forgotPasswordPending,
      forgotPassStatus: state.user.forgotPassword,
      forgotPasswordConfirmStatus: state.user.forgotPasswordVerify,
      currency: state.currency,
      isLoggedIn: state.user.isLoggedIn,
      redirectUrl: state.user.redirectUrl,
      isCreated: state.user.isCreated,
      isNew: state.user.isNew,
      isConfirmed: state.user.isConfirmed,
      isUnconfirmed: state.user.isUnconfirmed,
      email: state.user.user ? state.user.user.email : null,
      loginFetching: state.user.loginFetching,
      loginFetched: state.user.loginFetched,
      error: state.user.error,
      ressetPass: state.user.ressetPass,
      initialTokenRequestData: state.user.initialTokenRequestData
  };
}
const mapDispatchToProps = (dispatch) => ({
  //getUserData: (data) => dispatch(getUserData(data)),
  dispatch
});

export default withRouter(connect(MapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/containers/App.js